import React from 'react'
import '../Assets/WebsiteCss/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { IoLogoYoutube } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';


export default function WebFooter() {
  const navigate = useNavigate();

  return (
    <>

      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundColor: '#23326a' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={5}  >
                <h5 className='text-white'> Office</h5>
                <div className='d-flex '>
                  <span><FaLocationDot color='white' /></span>
                  <p className='text-white ms-2'>
                 Shop No.2, Dheeraj Apartment, Seth Bhagwandas Market Gali No.1, Kankroli Rajsamand GSTIN/UIN: 08CSDPS5207C2ZV State Name: Rajasthan, Code: 08
                  </p>
                </div>
              
                  

                  <div className='mb-2 '>
                  <a
      href="https://wa.me/9602910275"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
                   <span className='text-white'>
                    
                    <FaMobileAlt color='white' />  +91 9602910275 <span>+91 9660815610</span>
                    
                    </span>
                    </a>

                  
                 
                  </div>
                


                <div className='d-flex '>
                <a 
      href="mailto:info@nsnamkeenlabourcontractor.com"
      style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
    >
                  <span className='text-white'>
                    < MdEmail color='white' />  info@nsnamkeenlabourcontractor.com
                    </span>
                  </a>
                  
                </div>
                

              </Col>

              <Col lg={3}>
                <h5 className='text-white'>Policy</h5>


                <p className='text-white' onClick={() => navigate('/privacypolicy')} style={{ cursor: 'pointer' }}>
                  Privacy Policy
                </p>

                <p className='text-white' onClick={() => navigate('/termcondition')} style={{ cursor: 'pointer' }} >Term & Conditions</p>


              </Col>

              <Col lg={4}>
                <h5 className='text-white'>Connect With us</h5>
                <p className='text-white' >
                  We’re always looking to connect with tose who share an interest
                  in a sustainable future.
                </p>

             <div className="d-flex">
  <a
    className="iconback"
    href="https://www.facebook.com/profile.php?id=61556955840275"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit Narayan Salvi's Facebook profile"
  >
    <FaFacebookF />
  </a>

  <a
    className="iconback mx-3"
    href="https://youtube.com/@namkeenlabourcontractor4206?si=UZLlGbDghOQrcBd2"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit YouTube Channel"
  >
    <IoLogoYoutube />
  </a>

  <a
    className="iconback me-3"
    href="https://www.linkedin.com/in/narayan-salvi-68007375/"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit LinkedIn Profile"
  >
    <FaLinkedinIn />
  </a>

  <a
    className="iconback"
    href="https://www.instagram.com/ns_namkeen_labour_contractor/?utm_source=qr&igsh=MTNiYWE5dG40eTEzNQ%3D%3D"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit Instagram Profile"
  >
    <FaInstagram />
  </a>
</div>

              </Col>
            </Row>
           
            <div className='text-white mt-3 footerend text-center'>
            <hr />
              <p>© 2008 - {new Date().getFullYear()} NS Namkeen Labour Contractor.
                {/* <a href="https://www.bighostindia.in/" style={{color:'white',textDecoration:'none'}}>Design By : BigHost India Private Limited</a>  */}
                </p>
            </div>
          </Container>
        </div>
      </Col>


    </>
  )
}
